import { render } from "./TextAreaBlock.vue?vue&type=template&id=5ff16d49"
import script from "./TextAreaBlock.vue?vue&type=script&lang=js"
export * from "./TextAreaBlock.vue?vue&type=script&lang=js"

import "./TextAreaBlock.vue?vue&type=style&index=0&id=5ff16d49&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__